import React from 'react';
import properties from '../../modules/ajio-util/properties';

const imageBaseUrl = properties.getProperty('imageBaseUrl');

export default class extends React.Component {
  componentDidMount() {
    window.ga &&
      window.ga('send', {
        hitType: 'event',
        eventCategory: 'service error',
        eventAction: window.pageType,
        eventLabel: `OOPS_${window.location.pathname}`
      });
  }

  render() {
    const { mobile = false } = this.props;
    return (
      <div className="not-found-container notfound">
        <a href="/">
          <img
            className="not-found__image img-responsive"
            src={
              mobile ? `${imageBaseUrl}/static/img/404_m.jpg` : `${imageBaseUrl}/static/img/404.jpg`
            }
            alt="Page not available image"
            width="100%"
          />
        </a>
      </div>
    );
  }
}
